import { render } from "./TableElevated.vue?vue&type=template&id=31859a0f"
import script from "./TableElevated.vue?vue&type=script&lang=js"
export * from "./TableElevated.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/TableElevated.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31859a0f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31859a0f', __exports__)) {
    api.reload('31859a0f', __exports__)
  }
  
  module.hot.accept("./TableElevated.vue?vue&type=template&id=31859a0f", () => {
    api.rerender('31859a0f', render)
  })

}


export default __exports__